import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { Icon, PopupTooltip, hooks as coreHooks } from '@adc/ui-core'
import ChatUtils from '../../shared/util/chatUtils'
import { gtmLiveChatWidget } from '../../shared/services/tracking'
import styles from './styles.scss'
import { useApplicationContext } from '../auctionApplication/context'
const cx = classNames.bind(styles)

const ChatButton = ({ isFixedPosition, tooltipDisabled, trackChat }) => {
  const { user, featureFlags } = useApplicationContext()
  const enableV2Chat = featureFlags['fe.resi.enable-v2-chat']
  const canV2ChatLoad =
    typeof window !== 'undefined' && typeof document?.body !== 'undefined'

  // Storing user in a ref because the reference is outdated  when passing
  // onButtonClicked otherwise
  const userRef = useRef(user)
  coreHooks.useMountEffect(() => {
    if (enableV2Chat && canV2ChatLoad) {
      ChatUtils.loadSalesforceV2Chat(onButtonClicked)
    }
  })

  useEffect(() => {
    if (user.logged_in && enableV2Chat) {
      const { email, first_name, last_name } = user
      ChatUtils.setUserChatInfo(first_name, last_name, email)
      userRef.current = user
    }
  }, [user.logged_in, enableV2Chat])

  const startChat = _ => {
    trackChat()
    ChatUtils.openChatPopup(user)
  }

  const onButtonClicked = function () {
    const { email, first_name, last_name } = userRef.current
    ChatUtils.setUserChatInfo(first_name, last_name, email)
  }

  const classes = cx('chat-button-wrapper', {
    'chat-button-fixed': isFixedPosition,
  })

  if (enableV2Chat) {
    return <div data-elm-id='salesforce-v2-chat' />
  }

  return (
    <div className={classes}>
      <PopupTooltip
        trigger={
          <div
            data-elm-id='chat-button'
            className={cx('chat-button')}
            onClick={startChat}
          >
            <Icon
              iconStyle='light'
              name='comment-alt'
              color='white'
              className={cx('chat-icon')}
            />
          </div>
        }
        disabled={tooltipDisabled}
        hideOnScroll
        position='top'
        on='hover'
      >
        <div className='tooltip-content' data-elm-id='chat-tooltip'>
          Live Chat
        </div>
      </PopupTooltip>
    </div>
  )
}

ChatButton.propTypes = {
  isFixedPosition: PropTypes.bool,
  tooltipDisabled: PropTypes.bool,
  trackChat: PropTypes.func,
}

ChatButton.defaultProps = {
  isFixedPosition: true,
  tooltipDisabled: false,
  trackChat: gtmLiveChatWidget,
}

export default ChatButton
